import { render, staticRenderFns } from "./trunquee.vue?vue&type=template&id=2b45ccf8&scoped=true&"
import script from "./trunquee.vue?vue&type=script&lang=js&"
export * from "./trunquee.vue?vue&type=script&lang=js&"
import style0 from "./trunquee.vue?vue&type=style&index=0&id=2b45ccf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b45ccf8",
  null
  
)

export default component.exports